module.exports = __webpack_public_path__ + "img/sanja_bijaksic.f88c83ea.jpg";